import { Stack } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { ProjectTimeApprovalHistory } from "@repo/server-api";
import { useEffect, useState } from "react";

const DetailPanelContentTimeApprovals = ({
	history: history,
	columns: columnsProp,
}: {
	history: ProjectTimeApprovalHistory[];
	columns: GridColDef[];
}) => {
	const [items, setItems] = useState<ProjectTimeApprovalHistory[]>([]);

	useEffect(() => {
		setItems([
			...history.sort((a, b) => {
				return (
					new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
				);
			}),
		]);
	}, [history]);

	return (
		<Stack sx={{ height: "100%", boxSizing: "border-box" }} direction="column">
			{items.length ? (
				<DataGridPremium
					getRowId={(row: ProjectTimeApprovalHistory) =>
						items.indexOf(row).toString()
					}
					slots={{
						columnHeaders: () => null,
					}}
					density="compact"
					columns={columnsProp as GridCellParams<ProjectTimeApprovalHistory>[]}
					rows={items}
					sx={{ flex: 1 }}
					hideFooter
				/>
			) : (
				""
			)}
		</Stack>
	);
};

export default DetailPanelContentTimeApprovals;
